import { LOAD, ADD, DELETE, UPDATE, FORM_NAME } from 'model/role';
import {
  loadRoleById,
  loadRoles,
  addRole,
  deleteRole,
  updateRole,
} from 'sdk/role';
import {
  matchesExpectedRole,
  normalizeRoleSnapshot,
} from 'util/adminEntityMatch';
import { callActionWithSaveVerification } from 'util/longRunningMutation';
import { call, put, takeEvery } from 'redux-saga/effects';
import { ADMIN_SAVE_PHASE_SET } from 'reducers/adminSavePhase';
import { callAction } from '../util';

const updateRoleWithVerification = callActionWithSaveVerification({
  api: updateRole,
  verifyApi: loadRoleById,
  buildExpectedSnapshot: normalizeRoleSnapshot,
  getBaselineUpdatedAt: (data) => data.updatedAt ?? null,
  matchFn: matchesExpectedRole,
  formatSuccessMessage: (data) => `${data.name} Role has been updated.`,
  entityLabel: 'role',
  type: UPDATE,
});

const addRoleAction = callAction({
  api: addRole,
  formName: FORM_NAME,
  formatSuccessMessage: (data) => `${data.name} Role has been created.`,
  type: ADD,
});

const deleteRoleAction = callAction({
  api: deleteRole,
  formatSuccessMessage: (data) => `${data.name} Role has been removed.`,
  type: DELETE,
});

export function* addRoleWithSavePhase(action) {
  yield put({
    type: ADMIN_SAVE_PHASE_SET,
    payload: { formName: FORM_NAME, phase: 'saving' },
  });

  try {
    return yield call(addRoleAction, action);
  } finally {
    yield put({
      type: ADMIN_SAVE_PHASE_SET,
      payload: { formName: FORM_NAME, phase: null },
    });
  }
}

export function* deleteRoleWithSavePhase(action) {
  yield put({
    type: ADMIN_SAVE_PHASE_SET,
    payload: { formName: FORM_NAME, phase: 'saving' },
  });

  try {
    return yield call(deleteRoleAction, action);
  } finally {
    yield put({
      type: ADMIN_SAVE_PHASE_SET,
      payload: { formName: FORM_NAME, phase: null },
    });
  }
}

export function* updateRoleWithSavePhase(action) {
  yield put({
    type: ADMIN_SAVE_PHASE_SET,
    payload: { formName: FORM_NAME, phase: 'saving' },
  });

  try {
    return yield call(updateRoleWithVerification, action);
  } finally {
    yield put({
      type: ADMIN_SAVE_PHASE_SET,
      payload: { formName: FORM_NAME, phase: null },
    });
  }
}

export default function* saga() {
  yield takeEvery(ADD.ACTION, addRoleWithSavePhase);

  yield takeEvery(DELETE.ACTION, deleteRoleWithSavePhase);

  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: loadRoles,
      type: LOAD,
    })
  );

  yield takeEvery(UPDATE.ACTION, updateRoleWithSavePhase);
}
